window["goldlog"] = window["goldlog"] || {};
window["goldlog"].record = window["goldlog"].record || function () {};

const saasGray = !!window.saasGray;

export default function goldlog(key, ext) {
  if (!!!ext) {
    ext = key;
    key = "/pwa.weblite.log";
  }
  window["goldlog"].record(key, "CLK", `st_page_id=${window.pageId}&ext=${encodeURIComponent(ext)}`, "GET");
}

export function performanceLog(ext) {
  let key = "";
  switch (window.host) {
    case "msite":
      key = "/sc.ma.msite";
      break;
    case "weblite":
      key = "/sc.ma.weblite";
      if (saasGray) {
        key = "/sc.ma.im";
      }
      if (window.goldlog && window.goldlog.record) {
        window.goldlog.record(
          key,
          "CLK",
          `st_page_id=${window.pageId}&ext=${encodeURIComponent(ext)}`,
          "GET"
        );
        return;
      }
      break;
    case "messenger":
      key = "/sc.ma.messenger";
      break;
  }
  if (saasGray) {
    key = "/sc.ma.im";
  }
  window["IcbuIM"].lib.log(ext, key);
}
